import React from 'react';

import { Icon } from '@components/atoms';
import { css } from '@emotion/core';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
// import { ico16Hide, ico16Show } from '@images/svg';
import { color } from '@styles/themes';
import { Input as AInput, InputProps } from 'antd';
import { tuple } from 'antd/lib/_util/type';
import { PasswordProps, SearchProps, TextAreaProps } from 'antd/lib/input';

export const tYzTypeTextArea = tuple('form', 'surveyItem');

const { TextArea: ATextArea, Group: AInputGroup, Search: ASearch, Password: APassword } = AInput;

export interface TInputParams extends InputProps {}

export interface TTextAreaParams extends TextAreaProps {
  yzTypeTextArea?: (typeof tYzTypeTextArea)[number] | undefined;
}

export interface TPasswordParams extends PasswordProps {}

// type TIconType = {
//   disabled?: boolean;
// };

const StyledInput = styled(AInput)<TInputParams>`
  height: 36px;
  padding: 7px 12px 7px 12px !important;
  box-shadow: none !important;
  .ant-form-item-has-error &.ant-input {
    color: ${({ theme }) => theme.error3} !important;
  }
  .ant-input-prefix,
  .ant-input-suffix {
    position: relative;
    top: 1px;
  }
`;

export const Input = ({ ...rest }: TInputParams) => <StyledInput {...rest} />;

export const InputGroup = styled(AInputGroup)``;

export const TextArea = styled(ATextArea, { shouldForwardProp: isPropValid })<TTextAreaParams>`
  ${({ yzTypeTextArea }) => {
    switch (yzTypeTextArea) {
      case 'surveyItem': {
        return css`
          border: 1px solid #e5e5e5;
          border-radius: 12px !important;
          height: 100px !important;
          min-height: 100px !important;
          width: 100%;
          resize: none;
          color: ${color.infoText};
          padding: 16px;
          font-weight: 400 !important;
          font-size: 15px !important;
          line-height: 18px !important;
          letter-spacing: -0.01em !important;

          ::placeholder {
            font-weight: 400 !important;
            font-size: 15px !important;
            line-height: 18px !important;
            letter-spacing: -0.01em !important;
          }

          :active,
          :focus,
          :hover {
            border-color: #e5e5e5 !important;
            outline: none !important;
            box-shadow: 0 0 6px #e5e5e5;
          }

          !important &:disabled {
            background: rgba(142, 172, 255, 0.07);
            color: #363c50;
            border: 0;
          }
        `;
      }
      case 'form': {
        return css`
          border: 1px solid #e5e5e5;
          border-radius: 12px !important;
          height: calc(calc(100vh - 283px) * 0.9) !important;
          min-height: 100px !important;
          width: 100%;
          resize: none;
          color: ${color.infoText};
          padding: 16px;
          font-weight: 400 !important;
          font-size: 15px !important;
          line-height: 18px !important;
          letter-spacing: -0.01em !important;

          ::placeholder {
            font-weight: 400 !important;
            font-size: 15px !important;
            line-height: 18px !important;
            letter-spacing: -0.01em !important;
          }

          :active,
          :focus,
          :hover {
            border-color: #e5e5e5 !important;
            outline: none !important;
            box-shadow: 0 0 6px #e5e5e5;
          }

          !important &:disabled {
            background: rgba(142, 172, 255, 0.07);
            color: #363c50;
            border: 0;
          }
        `;
      }
      default: {
        return css``;
      }
    }
  }}
`;

const StyledSearch = styled(ASearch)`
  .ant-input {
    height: 36px !important;
    padding: 7px 32px 7px 12px !important;
    box-shadow: none !important;
    border-radius: 2px !important;
  }
  .ant-suffix-icon {
    vertical-align: 30px;
  }
  .ant-input-group-addon {
    width: 0;
    border: 0;
  }
  .ant-input-search-button {
    position: absolute;
    padding: 11px;
    top: 0;
    right: -1px;
    height: 100%;
    border: 1px solid transparent !important;
    background: transparent !important;
    z-index: 1;
    box-shadow: none !important;
    ${({ disabled, theme }) =>
      disabled &&
      css`
        svg path,
        svg g {
          stroke: ${theme.gray5} !important;
        }
      `}
    ::after {
      border: 1px solid ${({ theme }) => theme.link2} !important;
      opacity: 1;
      border-radius: 0 !important;
      box-shadow: none !important;
    }
  }
  box-shadow: none !important;
`;

interface TSearchParams extends SearchProps {}
export const Search = ({ ...rest }: TSearchParams) => (
  <StyledSearch enterButton={<Icon icon="ico16Search" />} {...rest} />
);

const StyledPassword = styled(APassword)<TPasswordParams>`
  height: 36px;
  padding: 7px 12px 7px 12px !important;
  box-shadow: none !important;
`;

// const Ico16Show = styled(ico16Show)<TIconType>`
//   ${({ disabled, theme }) =>
//     disabled &&
//     css`
//       g,
//       path {
//         stroke: ${theme.gray5};
//       }
//     `}
// `;
// const Ico16Hide = styled(ico16Hide)<TIconType>`
//   ${({ disabled, theme }) =>
//     disabled &&
//     css`
//       g,
//       path {
//         stroke: ${theme.gray5};
//       }
//     `}
// `;

export const Password = ({ ...rest }: TInputParams) => (
  <StyledPassword
    // iconRender={(visible) =>
    //   visible ? <Ico16Hide disabled={rest.disabled} /> : <Ico16Show disabled={rest.disabled} />
    // }
    {...rest}
  />
);
